import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

// const basePath = `${API_URLS.VEHICLE}/v3/Vehicle`;

const basePath = `${API_URLS.VEHICLE_V3}`;

function buildQuery(groupId, startDate, EndDate) {
  let AllGroupId =
    groupId === 0 || groupId === "0" || groupId === "TODOS" ? null : groupId;

  let queryParams = [];
  if (AllGroupId != null) {
    queryParams.push(`vehicleGroupId=${AllGroupId}`);
  }
  if (startDate) {
    queryParams.push(`StartDate=${startDate}`);
  }
  if (EndDate) {
    queryParams.push(`EndDate=${EndDate}`);
  }

  return queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
}

async function chartPizza(groupId) {
  try {
    var url = `${basePath}/dashboard/vehicles/ignition?${groupId}`;
    console.log(url);

    if (url) {
      let response = await api.get(url);
      let treated = errorHandling.handleResponse(
        response,
        "vehicleService.chartPizza",
      );
      if (treated) {
        return treated;
      }
      return null;
    } else {
      console.log("Parametros para busca de veículo não fornecidos!");
      return null;
    }
  } catch (error) {
    errorHandling.cathError(error, "vehicleService.chartPizza");
    return null;
  }
}

async function byDate(groupId, startDate, EndDate, id) {
  const queryString = buildQuery(groupId, startDate, EndDate, id);
  const url = `${basePath}/dashboard/vehicles/by-date${queryString}`;

  try {
    console.log(url);
    let response = await api.get(url);

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.by-date",
    );
    return treated || null;
  } catch (error) {
    errorHandling.cathError(error, "vehicleService.by-date");
    return null;
  }
}

async function mostActive(groupId, startDate, EndDate, id) {
  const queryString = buildQuery(groupId, startDate, EndDate, id);
  const url = `${basePath}/dashboard/vehicles/most-active${queryString}`;

  try {
    console.log(url);
    let response = await api.get(url);

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.most-active",
    );
    return treated || null;
  } catch (error) {
    errorHandling.cathError(error, "vehicleService.most-active");
    return null;
  }
}

async function mostIdle(groupId, startDate, EndDate, id) {
  const queryString = buildQuery(groupId, startDate, EndDate, id);
  const url = `${basePath}/dashboard/vehicles/most-idle${queryString}`;

  try {
    console.log(url);
    let response = await api.get(url);

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.most-idle",
    );
    treated.forEach((vehicle) => {
      vehicle.idleTime /= 60;
      vehicle.movingTime /= 60;
      vehicle.stoppedTime /= 60;
    });
    return treated || null;
  } catch (error) {
    errorHandling.cathError(error, "vehicleService.most-idle");
    return null;
  }
}

async function statusCount() {
  try {
    var url = `${basePath}/dashboard/vehicles/status-counts`;
    console.log(url);

    if (url) {
      let response = await api.get(url);

      let treated = errorHandling.handleResponse(
        response,
        "vehicleService.status-count",
      );
      if (treated) {
        return treated;
      }
      return null;
    } else {
      console.log("Parametros para busca de veículo não fornecidos!");
      return null;
    }
  } catch (error) {
    errorHandling.cathError(error, "vehicleService.status-count");
    return null;
  }
}

async function rankingDrivers(groupId, startDate, EndDate) {
  const queryString = buildQuery(groupId, startDate, EndDate);
  const url = `${basePath}/dashboard/drivers/ranking${queryString}`;

  try {
    console.log(url);
    let response = await api.get(url);

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.ranking-drivers",
    );
    return treated || null;
  } catch (error) {
    errorHandling.cathError(error, "vehicleService.ranking-drivers");
    return null;
  }
}

async function afterHours(groupId, startDate, EndDate) {
  const queryString = buildQuery(groupId, startDate, EndDate);
  const url = `${basePath}/dashboard/vehicles/after-hours${queryString}`;

  try {
    console.log(url);
    let response = await api.get(url);

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.after-hours",
    );
    return treated || null;
  } catch (error) {
    errorHandling.cathError(error, "vehicleService.after-hours");
    return null;
  }
}

async function weeks(groupId, startDate, EndDate) {
  const queryString = buildQuery(groupId, startDate, EndDate);
  const url = `${basePath}/dashboard/vehicles/3weeks${queryString}`;

  try {
    console.log(url);
    let response = await api.get(url);

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.weeks",
    );
    return treated || null;
  } catch (error) {
    errorHandling.cathError(error, "vehicleService.weeks");
    return null;
  }
}

async function speeding(groupId, startDate, EndDate) {
  // se groupId for 0 ou "TODOS", não passa o parâmetro
  let AllGroupId =
    groupId === 0 || groupId === "0" || groupId === "TODOS" ? null : groupId;

  let queryParams = [];

  if (AllGroupId != null) {
    queryParams.push(`vehicleGroupId=${AllGroupId}`);
  }
  if (startDate) {
    queryParams.push(`StartDate=${startDate}`);
  }
  if (EndDate) {
    queryParams.push(`EndDate=${EndDate}`);
  }

  const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
  const url = `${basePath}/dashboard/vehicles/speeding${queryString}`;

  try {
    console.log(url);
    let response = await api.get(url);

    let treated = errorHandling.handleResponse(
      response,
      "vehicleService.speeding",
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "vehicleService.speeding");
    return null;
  }
}

export const dashboardService = {
  byDate,
  chartPizza,
  mostActive,
  mostIdle,
  statusCount,
  rankingDrivers,
  afterHours,
  weeks,
  speeding,
};
